import styled, { css } from "styled-components";

export const StyleContactAll = styled.button<{ map: boolean }>`
	display: flex;
	position: fixed;
	 bottom: ${(props) => (props.map ? "25px" : "32px")};
	  right: ${(props) => (props.map ? "60px" : "33px")};
	z-index: 99;
	background-color: #7c9473;
	cursor: pointer;
	width: 44px;
	height: 44px;
	border-radius: 12px 4px 12px 12px;
	background: #689e2e;
	box-shadow: 0 0 5px rgba(0, 0, 0, 0.16);
	border: none;
	&:hover {
		box-shadow: 0 0 15px rgba(0, 0, 0, 0.16);
	}
	& img {
		height: 20px;
	}
	@media screen and (max-width: 768px) {
	 bottom: ${(props) => (props.map ? "25px" : "12px")};
	  right: ${(props) => (props.map ? "60px" : "16px")};
	}
`;
export const ContactAllOnClick = styled.div`
	display: inline-flex;
	padding: 12px;

	justify-content: center;
	align-items: center;
	border-radius: 12px 4px 12px 12px;
	background: #689e2e;
`;
export const ContactAllImg = styled.img`
	width: 20px;
	height: 20px;
`;
export const ContactQuickCallLink = styled.a`
	display: inline-flex;
	position: absolute;
	right: 0;
	bottom: calc(100% + 12px);
	width: 44px;
	height: 44px;
	align-items: center;
	justify-content: center;
	border-radius: 12px 4px 12px 12px;
	background: #689e2e;
	box-shadow: 0 0 5px rgba(0, 0, 0, 0.16);
	text-decoration: none;
	transition: transform 0.18s ease, box-shadow 0.18s ease;

	&:hover {
		transform: translateY(-1px);
		box-shadow: 0 0 15px rgba(0, 0, 0, 0.16);
	}
`;
export const ContactQuickCallImg = styled.img`
	width: 20px;
	height: 20px;
`;
export const ContactAllWrap = styled.div`
	position: relative;
`;
export const ContactAllRef = styled.div`
	position: absolute;
	bottom: 48px;
	right: 0px;
	background-color: rgb(255, 255, 255);
	box-shadow: rgba(0, 0, 0, 0.04) 10px 12px 16px 12px;
	border-radius: 12px;
	padding: 4px 0px;
	border: 1px solid #d1d5db;
`;
export const ContactAllInner = styled.div`
	display: flex;
	padding: 10px 16px;
	align-items: center;
`;
export const ContactAllInnerImg = styled.img`
	width: 36px;
	height: 36px !important;
	margin-right: 8px;
	@media screen and (max-width: 768px) {
		width: 24px;
		height: 24px !important;
	}
`;
export const ContactAllInnerName = styled.div`
	ont-size: 16px;
	font-style: normal;
	font-weight: 500;
	line-height: 24px;
`;
